<template>
    <div class="c-showroom-2025__anchor" :id="'marque-'+make"></div>
    <h2 class="c-showroom-2025__brand-title sr-only">
        {{ make }}
    </h2>
    <div class="c-showroom-2025__brand-logo">
        <svgIco :icon="'marque-'+make" />
    </div>
    <div class="c-showroom-2025-cars-types -desktop">
        <button class="c-showroom-2025-cars-types__item" :class="{'is-active': category=='all'}" @click="category = 'all'">
            Voir tout
        </button>
        <button v-for="(c,i) in categories" :key="i" class="c-showroom-2025-cars-types__item" :class="{'is-active': category==c}" @click="category = c">
            {{ c }}
        </button>
        
    </div>
    <div class="c-showroom-2025-cars-types -mobile">
        <div class="o-select__wrap">
            <select class="o-select c-showroom-2025-cars-types__select" v-model="category">
                <option value="all">Voir tout</option>
                <option v-for="(c,i) in categories" :key="i" :value="c">{{ c }}</option>
            </select>
        </div>
    </div>
    <div class="c-showroom-2025-prices-selector__wrap">
        <div class="c-showroom-2025-prices-selector">
            <div class="c-showroom-2025-prices-selector__item" :class="{'is-active': price=='cash'}">
                <button class="c-showroom-2025-cars-types__btn" @click="price = 'cash'">
                    Prix comptant
                </button>
            </div>
            <div class="c-showroom-2025-prices-selector__item" :class="{'is-active': price=='weekly'}">
                <button class="c-showroom-2025-cars-types__btn" @click="price = 'weekly'">
                    Paiement/semaine
                </button>
            </div>
        </div>
    </div>
    <div class="c-showroom-2025-cars-list">
        
        <div class="c-showroom-2025-car" v-for="(item,i) in filteredItems" :key="i">
            <div class="c-showroom-2025-car__img">
                <a :href="item.url"><img :src="item.image" :alt="item.make+' '+item.model" /></a>
            </div>
            <div class="c-showroom-2025-car__years">
                <a class="c-showroom-2025-car__year is-active" :href="item.url">
                    <span>{{ item.annee }}</span>
                    <svgIco v-if="item.carburants.includes('electric')" icon="2025-electric" class="c-showroom-2025-car__year__ico" />
                </a>
                <a v-if="item.prev" class="c-showroom-2025-car__year" :href="item.prev.url">
                    <span>{{ item.prev.annee }}</span>
                </a>
            </div>
            <div class="c-showroom-2025-car__info">
                <h3 class="c-showroom-2025-car__title">
                    <a :href="item.url">{{ item.make }} {{ item.model }}</a>
                </h3>
                <p class="c-showroom-2025-car__price" v-if="item.prix < 300000 && price=='weekly'">
                    <span class="c-showroom-2025-car__alttext">À partir de</span>
                    <!--span class="c-showroom-2025-car__stroke">72,99 $/sem</span-->
                    <strong v-if="item.weekly" :class="{'c-showroom-2025-car__rebate': !item.weekly || !item.weekly.rebate, 'c-showroom-2025-car__strong': item.weekly && item.weekly.rebate}"> {{cents(item.weekly.weekly)}}/sem</strong>
                    <span v-if="item.weekly && item.weekly.rebate" class="c-showroom-2025-car__rebate">Rabais de {{ cash(item.weekly.rebate) }}  <svgIco icon="2025-deal" /></span>
                </p>
                <p class="c-showroom-2025-car__price" v-if="item.prix < 300000 && price=='cash'">
                    <span class="c-showroom-2025-car__alttext">À partir de</span>
                    <span class="c-showroom-2025-car__stroke" v-if="item.rebate">{{cash(item.prix)}}</span>
                    <strong :class="{'c-showroom-2025-car__rebate': !item.rebate, 'c-showroom-2025-car__strong': item.rebate}">  {{ cash(item.prix-item.rebate) }}</strong>
                    <span v-if="item.rebate" class="c-showroom-2025-car__rebate">Rabais de {{ cash(item.rebate) }}  <svgIco icon="2025-deal" /></span>
                </p>
            </div>
        </div>
        
    </div>
</template>
<script>


export default {
    name: 'ShowroomMake',
    props: {
        make: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            items: window.lpdgshowroom.items.filter(item => item.make.toLowerCase() === this.make.toLowerCase()),
            category: 'all',
            price: 'cash'
        }
    },
    computed: {
        filteredItems() {
            if (this.category === 'all') {
                return this.items;
            }
            return this.items.filter(item => item.cats.includes(this.category));
        },
        categories() {
            return [...new Set(this.items.map(item => item.cats).flat())].sort();
        }
    },

    methods: {
        
    }
}
</script>